import i18n from './i18n'

export const getErrorMessage = (messages) => {
  if (!messages.length) return ''
  const firstMes = messages[0]
  if (i18n.te(firstMes.id)) {
    return i18n.t(firstMes.id)
  } else {
    return firstMes.message
  }
}